import Routes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'construction-schedule-management',
  title: '施工任务计划管理',
  version: '0.1.6',
  description: '对任务计划进度进行管理',
  routes: Routes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['DataCategoryApi', 'CatalogueApi', 'UnitApi'],
  },
  config: {
    currentEnv: {},
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
